
var stringFunctions = {
	htmlDecode(input) {
		var doc = new DOMParser().parseFromString(input, "text/html");
		return doc.documentElement.textContent.replaceAll("’", "'");
	},
	atMax3Paragraphs(text) {
		let shortenedText = text.split("<br").slice(0, 6).join("<br");
		return (shortenedText.length == text.length) ? text : shortenedText + '(more...)';
	},
}

export default stringFunctions
